export enum StorageUnitType {
  CABINET = 1,
  FRIDGE = 2,
  TABLE = 3,
}

export enum PlacementSide {
  R = 1,
  L = 2,
}

export enum AisleLayout {
  LEFT = 1,
  RIGHT = 2,
  BOTH = 3,
}

export enum BinPosition {
  LEFT = 1,
  CENTER = 2,
  RIGHT = 3,
}

export enum LocationRole {
  PRIMARY = 1,
  OVERFLOW = 2,
}

export enum VerificationMethod {
  PRODUCT_BARCODE = 1,
  PRINTED_LABEL = 2,
  LOCATION_ONLY = 3,
}
